import type { ComponentChildren } from 'preact';

interface Column<T> {
  key: string;
  label: string;
  render: (row: T) => ComponentChildren;
  width?: string;
}

interface Props<T> {
  rows: T[];
  columns: Column<T>[];
  empty?: string;
  rowKey?: (row: T) => string;
  onRowClick?: (row: T) => void;
}

export function DataTable<T extends Record<string, unknown>>({
  rows,
  columns,
  empty = 'Nenhum item para exibir.',
  rowKey,
  onRowClick,
}: Props<T>) {
  return (
    <div class="rounded-lg border border-border bg-card text-card-foreground shadow-sm overflow-hidden">
      <table class="w-full text-sm">
        <thead>
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                class="text-left text-xs font-medium text-muted-foreground px-3 py-2 bg-muted border-b border-border"
                style={c.width ? `width: ${c.width}` : undefined}
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} class="px-3 py-6 text-center text-muted-foreground text-xs">
                {empty}
              </td>
            </tr>
          ) : (
            rows.map((r, i) => (
              <tr
                key={rowKey?.(r) ?? i}
                class={`border-b border-border last:border-b-0 ${
                  onRowClick ? 'cursor-pointer hover:bg-muted/50' : ''
                }`}
                onClick={onRowClick ? () => onRowClick(r) : undefined}
              >
                {columns.map((c) => (
                  <td key={c.key} class="px-3 py-2 text-sm align-top">
                    {c.render(r)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
